import { render, staticRenderFns } from "./NodeWebhooks.vue?vue&type=template&id=8ded0cf6&scoped=true&"
import script from "./NodeWebhooks.vue?vue&type=script&lang=ts&"
export * from "./NodeWebhooks.vue?vue&type=script&lang=ts&"
import style0 from "./NodeWebhooks.vue?vue&type=style&index=0&id=8ded0cf6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ded0cf6",
  null
  
)

export default component.exports